function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { forwardRef } from 'react';
import { IconButton } from '../../../components/action';
import { useDrawerContext } from '../DrawerContext';
/**
 * @private For internal use only. Should be consumed only by `Drawer`.
 */

import { jsx as _jsx } from "react/jsx-runtime";
export var DrawerCloseButton = /*#__PURE__*/forwardRef((props, ref) => {
  var {
    onClose,
    closeButtonAriaLabel,
    getTestId
  } = useDrawerContext();
  return /*#__PURE__*/_jsx(IconButton, _objectSpread(_objectSpread({
    "data-component": "DrawerCloseButton",
    ref: ref,
    "aria-label": closeButtonAriaLabel,
    icon: "close",
    onClick: onClose
  }, getTestId('close-button')), props));
});
DrawerCloseButton.displayName = 'DrawerCloseButton';
//# sourceMappingURL=DrawerCloseButton.js.map